import styled, { keyframes } from 'styled-components'
import theme from 'theme_'
import Icon from '@mdi/react'
import { Font14, Font16 } from 'components/Typography'
import { ApplyLicenseWrapper } from 'features/home/components/HomeLicensing/AvailableLicenses/HomeLicensesGroupsTable/ApplyLicense/styles'

export const LicensesGroupContainer = styled.div<{ showGroup: boolean }>`
  display: ${(p) => (p && p.showGroup ? 'flex' : 'none')};
  flex-direction: column;
`

const collapseAnimation = keyframes`
 0% { opacity: 0; }
 100% { opacity: 1; }
`

export const CollapseContainer = styled.div<{ collapse: boolean }>`
  display: ${(p) => (p.collapse ? 'block' : 'none')};
  animation-name: ${collapseAnimation};
  animation-duration: 0.5s;
`

export const LicensesGroupSummary = styled.div<{ collapse: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  background: ${(p) =>
    p && p.collapse ? theme.colors.hoverState : theme.colors.white};
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  :hover {
    background: ${theme.colors.hoverState};
  }
`

export const LicensesGroupsRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const LicensesGroupsLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const LicenseIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  color: ${theme.colors.dolphinGrey};
`

export const DropDownIcon = styled(Icon)`
  width: 16px;
  height: 16px;
  color: ${theme.colors.horizonOrange};
  transition: all 0.2s ease;
  :hover {
    opacity: 0.8;
  }
`
export const LicensesGroupsDescription = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
`

export const LicensesGroupsTitle = styled.div`
  font-weight: 900;
  ${Font16};
  color: ${theme.colors.otterWarmBlack};
  margin-bottom: 8px;
`

export const RowCount = styled.div`
  font-weight: 900;
  ${Font14};
  color: ${theme.colors.otterWarmBlack};
  margin-right: 24px;
`

export const StyledTableInnerWrapper = styled.div`
  @media ${theme.devices.tablet} {
    min-width: 100%;
    width: max-content;
  }

  ${ApplyLicenseWrapper} {
    display: none;
  }
`

export const StyledTableOuterWrapper = styled.div`
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  margin-bottom: 8px;
  overflow-x: auto;

  @media ${theme.devices.mediumDesktop} {
    overflow-x: initial;
    display: flex;
  }
`
